var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCasaIcone = function SvgCasaIcone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9931 0C10.4851 0 10.9311 0.167 11.3311 0.502L19.6531 7.245C19.9811 7.594 20.0671 7.971 19.9111 8.377C19.7551 8.784 19.4461 8.987 18.9841 8.989L18.0001 9V18C18.0001 19.333 17.3331 20 16.0001 20H14.0001C12.6671 19.99 12.0001 19.324 12.0001 18V12H8.0001V17.986C8.0001 19.31 7.3331 19.976 6.0001 19.986H4.0001C2.6671 19.996 2.0001 19.333 2.0001 18L1.9961 9L0.968101 8.989C0.485101 8.989 0.182101 8.785 0.0571006 8.377C-0.0678994 7.97 0.0141006 7.591 0.303101 7.241L8.6551 0.502C9.0551 0.167 9.5021 0 9.9931 0V0Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCasaIcone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/casa-icone.d83640a5.svg";
export { ForwardRef as ReactComponent };